export const normal_post_list: any = {
  "1": "1",
  "2": "2",
  "3": "2",
  "4": "2",
  "5": "1",
  "6": "1",
  "7": "2",
  "8": "1"
}